<template>
  <div class="instagram margin-between-section">
    <!--<div id="carouselExampleControlss" class="carousel slide" data-ride="carousels">-->
      <a href="#" class="tag-i">@pragmaticscouting</a>
      <!-- SnapWidget -->
      <!-- SnapWidget -->
      <iframe src="https://snapwidget.com/embed/874861" class="snapwidget-widget" allowtransparency="true" frameborder="0" scrolling="no" style="border:none; overflow:hidden;"></iframe>
      <!--<div class="carousel-inner">
        <div class="carousel-item active gall">
          <div class="row">
            <div class="col-md-3 not-margin not-padding">
              <img src="../assets/images/banner.png"/>
            </div>
            <div class="col-md-3 not-margin not-padding">
              <img src="../assets/images/banner2.png"/>
            </div>
            <div class="col-md-3 not-margin not-padding">
              <img src="../assets/images/banner3.png"/>
            </div>
            <div class="col-md-3 not-margin not-padding">
              <img src="../assets/images/banner.png"/>
            </div>
          </div>
        </div>
        <div class="carousel-item gall">
          <div class="row">
            <div class="col-md-3 not-margin not-padding">
              <img src="../assets/images/banner.png"/>
            </div>
            <div class="col-md-3 not-margin not-padding">
              <img src="../assets/images/banner2.png"/>
            </div>
            <div class="col-md-3 not-margin not-padding">
              <img src="../assets/images/banner3.png"/>
            </div>
            <div class="col-md-3 not-margin not-padding">
              <img src="../assets/images/banner.png"/>
            </div>
          </div>
        </div>
        <a class="carousel-control-prev" href="#carouselExampleControlss" role="button" data-slide="prev">
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="sr-only">Previous</span>
        </a>
        <a class="carousel-control-next" href="#carouselExampleControlss" role="button" data-slide="next">
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="sr-only">Next</span>
        </a>
        <div class="col-md-12 not-padding">
        <img src="../assets/images/about.png">
        <h1>Síguenos en Instagram para más contenido:</h1>
      <instagram-embed :url="'https://www.instagram.com/p/Bs_yHwHBjKo/'" :max-width=500 />
      </div>
      </div>
    </div>-->
  </div>
</template>

<script>

//import InstagramEmbed from 'vue-instagram-embed';
//import VueInstagram from 'vue-instagram'

export default {
  name: 'instagram',
  components: {
    //VueInstagram
  }
};

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.instagram{
  position: relative;
}

iframe {
  width: 100%;
  height:215px
}

iframe img{
  width: 100%;
  object-fit: cover;
}

.tag-i{
  position: absolute;
  z-index: 1;
  height: 20px;
  width: 100px;
  color: #fff;
  text-decoration: none;
  font-family: 'plain medium', arial;
  top: 0;
  left: 0;
  margin-top: 150px;
  margin-left: 50%;
  transform: translate(-75px, -50%);
}

.carousel-control-next, .carousel-control-prev {
  background: #fff;
  border: 1px solid #fff;
  width: 40px;
  height: 40px;
  opacity: 1;
  top: 130px;
  margin-right: 20px;
}

.carousel-control-prev {
  margin-left: 20px;
}




.carousel-control-next-icon{
  background: url('../assets/images/right.png');
  background-repeat: no-repeat;
  background-position: center;
}


.carousel-control-prev-icon{
  background: url('../assets/images/left.png');
  background-repeat: no-repeat;
  background-position: center;
}

.info{
  text-align: left;
}

.info h1{
  font-size: 25px;
  font-family: 'plain regular', arial
}

.info p{
  padding-top: 5%;
  font-size: 18px;
}

.container-info{
  display: flex;
  align-items: center;
}

.not-margin{
  margin: 0;
}
.not-padding{
  padding: 0;
}

.img-tw{
  width: 48px;
  margin-bottom: 20px;
}

.gall{
  width: 100%;
  height: 300px;
}
.gall div{
  height: 300px;
}
.gall img{
  width: 100%;
  height: 100%;
  object-fit: cover
}


iframe {
  width: 100%;
  height: 336px
}


/* Larger than tablet */
@media (max-width: 768px) {

  iframe {
    width: 100%;
    height: 250px
  }
}

@media (max-width: 550px) {
  iframe {
    width: 100%;
    height: 150px
  }
}


/* Larger than mobile */
@media (max-width: 400px) {
  iframe {
    width: 100%;
    height: 140px
  }
}




</style>
